import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"scrollable":"","fullscreen":"","persistent":"","overlay":false,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.getModalListarVenda),callback:function ($$v) {_vm.getModalListarVenda=$$v},expression:"getModalListarVenda"}},[_c('ListarVendaCard',{attrs:{"botaoVisualizarVendaTroca":"false"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }